import PatientFormModal from "./PatientFormModal";
import { PatientFormData } from "../utils/patientValidation";

interface CustomerListModalProps {
  isOpen: boolean;
  onClose: () => void;
  onClaim: (customerData: PatientFormData) => Promise<void>;
}

const validateAddressForCreate = (address: string): string => {
  if (!address.trim()) return "Address is required";
  const trimmedAddress = address.trim();

  if (trimmedAddress.length > 200) return "Address is too long (maximum 200 characters)";
  if (trimmedAddress.length < 5) return "Please enter a complete US address";

  const addressRegex = /^\d+\s+[a-zA-Z0-9][a-zA-Z0-9\s.,#-]*$/;
  if (!addressRegex.test(trimmedAddress)) {
    return "Please enter a valid US address format (e.g., 123 Main St)";
  }

  return "";
};

const CustomerListModal: React.FC<CustomerListModalProps> = ({ isOpen, onClose, onClaim }) => {
  return (
    <PatientFormModal
      isOpen={isOpen}
      title="RSA Order Form"
      subtitle="Enter customer details manually"
      primaryLabel="Create RSA Order"
      loadingLabel="Creating..."
      onClose={onClose}
      onSubmit={onClaim}
      validateAddress={validateAddressForCreate}
      defaultErrorMessage="Failed to create RSA order. Please try again."
      buildConflictMessage={(data, error) =>
        error?.status === 409
          ? `A customer with phone number ${data.phoneNumber} already exists. Please use a different phone number.`
          : null
      }
    />
  );
};

export default CustomerListModal;
